import React from 'react';
import { FileText, Users, CheckCircle } from 'lucide-react';
import { howItWorksSteps } from '../data/mockData';

const iconMap = {
  FileText: FileText,
  Users: Users,
  CheckCircle: CheckCircle
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-container">
      <div className="section-content">
        <div className="section-header">
          <h2 className="section-title">How FindMeAgent Works</h2>
          <p className="section-description">
            Get matched with the perfect real estate agent in three simple steps
          </p>
        </div>

        <div className="steps-grid">
          {howItWorksSteps.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.id} className="step-card">
                <div className="step-number">{step.id}</div>
                <div className="step-icon-wrapper">
                  <IconComponent className="step-icon" size={32} />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                {index < howItWorksSteps.length - 1 && (
                  <div className="step-connector"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
